// components/profile/components/FormField.jsx
import React from 'react';
import { Typography, Tooltip, IconButton } from '@material-tailwind/react';
import { InformationCircleIcon } from '@heroicons/react/24/outline';

export const FormField = ({ 
  label, 
  required = false, 
  helperText, 
  tooltipText, 
  children, 
  error,
  isEmpty,
  success,
  hideCompletionIcon = false,  // Add this prop
  labelStyle,
  labelAction                    // Add this prop for custom label styling
}) => {
  return (
    <div className="space-y-2">
      {/* Label with tooltip */}
      <div className="flex items-center gap-2">
        {labelStyle ? (
          // Use custom style when provided
          <label style={labelStyle}>
            {label}
            {required && isEmpty && (
              <span className="text-red-500 ml-1">*</span>
            )}
            {/* Only show checkmark if hideCompletionIcon is false */}
            {!hideCompletionIcon && required && !isEmpty && !error && (
              <span className="text-green-500 ml-1">✓</span>
            )}
          </label>
        ) : (
          // Fallback to Material Tailwind Typography
          <Typography variant="small" className="font-medium text-gray-700">
            {label}
            {required && isEmpty && (
              <span className="text-red-500 ml-1">*</span>
            )}
            {/* Only show checkmark if hideCompletionIcon is false */}
            {!hideCompletionIcon && required && !isEmpty && !error && (
              <span className="text-green-500 ml-1">✓</span>
            )}
          </Typography>
        )}
        
        {tooltipText && (
          <Tooltip 
            content={
              <div className="max-w-xs">
                <Typography variant="small" className="text-white">
                  {tooltipText}
                </Typography>
              </div>
            } 
            placement="top"
            className="bg-gray-900"
          >
            <IconButton variant="text" size="sm" className="p-0">
              <InformationCircleIcon className="h-4 w-4 text-gray-400 hover:text-gray-600" />
            </IconButton>
          </Tooltip>
        )}

        {labelAction && (
          <div className="ml-2">
            {labelAction}
          </div>
        )}
      </div>
      
      {/* Input/Content */}
      <div className={error ? 'has-error' : success ? 'has-success' : ''}>
        {children}
      </div>
      
      {/* Helper text or error message */}
      {error ? (
        <Typography variant="small" className="text-red-500 flex items-center gap-1">
          <span className="inline-block w-1 h-1 bg-red-500 rounded-full"></span>
          {error}
        </Typography>
      ) : helperText ? (
        <Typography variant="small" className="text-gray-500">
          {helperText}
        </Typography>
      ) : null}
    </div>
  );
};